import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=bc5a0a28&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=bc5a0a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a0a28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5a0a28')) {
      api.createRecord('bc5a0a28', component.options)
    } else {
      api.reload('bc5a0a28', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=bc5a0a28&scoped=true&", function () {
      api.rerender('bc5a0a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Banner.vue"
export default component.exports